import type {FC} from 'react';
import {
  Datagrid,
  DateField,
  DeleteButton,
  Edit,
  EditButton,
  ReferenceField,
  ReferenceInput,
  required,
  SelectInput,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar,
} from 'react-admin';

const STATUS_CHOICES = [
  {id: 'DATA_PENDING', name: 'DATA_PENDING'},
  {id: 'DATA_UPLOADED', name: 'DATA_UPLOADED'},
];

const ToolbarDeleteOnly: FC = (props) => (
  <Toolbar {...props}>
    <DeleteButton />
  </Toolbar>
);

export const SlamPointCloudEdit: FC = () => (
  <Edit>
    <SimpleForm toolbar={<ToolbarDeleteOnly />}>
      <ReferenceInput source="inventoryPlotUuid" reference="inventory-plots">
        <SelectInput optionText="code" validate={[required()]} />
      </ReferenceInput>
      <ReferenceInput source="lidarTechnologyUuid" reference="lidar-technologies">
        <SelectInput optionText="name" validate={[required()]} />
      </ReferenceInput>
      <SelectInput source="status" choices={STATUS_CHOICES} validate={[required()]} />
      <TextInput source="date" validate={[required()]} />
      <TextInput source="comments" multiline />
    </SimpleForm>
  </Edit>
);

export const SlamPointCloudDatagrid: FC = () => (
  <Datagrid rowClick="edit">
    <TextField source="status" />
    <DateField source="date" />
    <ReferenceField source="lidarTechnologyUuid" reference="lidar-technologies" label="Lidar Tech">
      <TextField source="name" />
    </ReferenceField>
    <TextField source="comments" />
    <EditButton />
    <DeleteButton />
  </Datagrid>
);
